import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import type { Translations } from '../../types/translations';
import { getTranslations } from '../../api/translations/translations';
import { useStoreConfiguration } from '../configuration/configuration';
import fallbackTranslations from './fallback/en.json';

const storeId = 'store-translations';
const storeLocale = 'store-locale';
const storeLanguage = 'store-language';
const storeLocaleData = sessionStorage.getItem(storeLocale);
const storeLanguageData = sessionStorage.getItem(storeLanguage);
const localeLowerCase = ref<string | null>(null);

export const useStoreTranslations = defineStore(storeId, () => {
  const storeConfiguration = useStoreConfiguration();
  const translations = ref<Translations>();

  async function init() {
    const { caasConfig, caasUrl, config } = storeConfiguration;

    if (!caasConfig || !caasUrl || !config) {
      console.error(`${storeId} >>> error`, 'caas configuration or URL is not available');
    } else {
      const { caas_translationServiceUrl: translationsServiceUrl } = config;

      const { masterLocale, stage, masterProject } = caasConfig ?? {};

      localeLowerCase.value = (caasConfig.locale || caasConfig.language)?.toLowerCase();
      const languageLowerCase = caasConfig?.language?.toLocaleLowerCase();

      translations.value = {
        ...fallbackTranslations,
        ...(await getTranslations({
          caasUrl,
          translationsServiceUrl,
          masterProject,
          stage,
          masterLocale,
          languageLowerCase,
        })),
      };

      return;
    }
  }

  watch(
    () => storeConfiguration.config,
    () => {
      if (
        (storeConfiguration.config && !translations.value) ||
        (storeConfiguration.config && localeLowerCase.value !== storeLocaleData)
      ) {
        init();
      }
    },
    { deep: true },
  );

  watch(
    () => storeConfiguration.caasConfig,
    (newValue, oldValue) => {
      if (
        (newValue !== oldValue &&
          newValue &&
          newValue?.language?.toLowerCase() !== storeLanguageData) ||
        storeLocaleData !== storeLanguageData
      ) {
        init();
      }
    },
    { deep: true },
  );

  return { translations };
});
